import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { SliceName } from '../../name';
import { StudioReducerProps } from './type';
import { StudioPhoto } from '@core/models';
import {
  fetchGalleryImagesReducer,
  uploadStudioPhotosReducer,
  deleteStudioPhotosReducer,
  updateStudioPhotoReducer,
  fetchSocialPostsReducer,
} from './thunks';

const studioSlice = createSlice<StudioReducerProps, SliceCaseReducers<StudioReducerProps>, string>({
  name: SliceName.Studio,
  initialState: {
    socialPosts: [],
    studioPhotos: [],
    isLoading: false,
  },
  reducers: {
    setStudioPhotos(state, action: PayloadAction<StudioPhoto[]>) {
      state.studioPhotos = action.payload;
    },
  },
  extraReducers: {
    ...fetchSocialPostsReducer,
    ...fetchGalleryImagesReducer,
    ...uploadStudioPhotosReducer,
    ...deleteStudioPhotosReducer,
    ...updateStudioPhotoReducer,
  },
});

export const { setFileImageItems } = studioSlice.actions;
export const studioReducer = studioSlice.reducer;
